import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';

import { PortfolioAccordionSummary } from '../PortfolioAccordionSummary';
import { PortfolioAccordionSummaryMetric } from '../PortfolioAccordionSummaryMetric';

import {
  PrivacyContextAwareMoneyValue,
  RENTAL_INCOME_COLOR,
  RentalIncomePercentText,
  RentalIncomePercentTypography,
} from '../../../common';

const StyledRentalIncomeAccordionSummary = styled(PortfolioAccordionSummary)`
  .value {
    text-align: right;
  }
`;

export interface RentalIncomeAccordionSummaryProps {
  allTimeRentalIncome: number;
  className?: string;
  rentalIncomePercent: number;
}

export const RentalIncomeAccordionSummary = ({
  allTimeRentalIncome,
  className,
  rentalIncomePercent,
}: RentalIncomeAccordionSummaryProps) => {
  return (
    <StyledRentalIncomeAccordionSummary
      className={className}
      color={RENTAL_INCOME_COLOR}
      title={<FormattedMessage id="rental-income" defaultMessage="Rental Income" />}
    >
      <div className="value">
        <PortfolioAccordionSummaryMetric color={RENTAL_INCOME_COLOR}>
          <PrivacyContextAwareMoneyValue value={allTimeRentalIncome} length={4} />
        </PortfolioAccordionSummaryMetric>
        <RentalIncomePercentTypography>
          <RentalIncomePercentText rentalIncomePercent={rentalIncomePercent} />
        </RentalIncomePercentTypography>
      </div>
    </StyledRentalIncomeAccordionSummary>
  );
};
